import Modal from 'react-bootstrap/Modal';
import {setShowLogin} from 'actions/index.js';
import ShareWithPeople from './ShareWithPeople.js';
import {getOrMakeGuildWith} from 'decentralized/guilds/getOrMakeGuildWith.js';
import UnknownProgressBar from 'components/progressbar/UnknownProgressBar.js';
import ExportProgressBar from 'components/progressbar/ExportProgressBar.js';
import {bounce} from 'engine/BouncingEngine.js';
import SaveRecordingsComponent from './SaveRecordingsComponent.js';
import PrivacyNote from './PrivacyNote.js';
import { Button } from 'reactstrap';
import accounts from 'accounts/Accounts.js';
import LinkCreator from './LinkCreator.js';
import GuildOptions from './GuildOptions.js';
import PulseLoader from 'react-spinners/PulseLoader'
import EthereumExplanation from './EthereumExplanation.js';
import React, { Component } from 'react';
import axios from 'axios';
import {isNumber} from 'utils/IsNumber.js';
import MetamaskInstructions from './MetamaskInstructions.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {setShowModsModal, setContextualHelp} from 'actions/index.js';
import EffectMods from 'components/effects/EffectMods.js';
import {  InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {PUBLIC_SAVE, PRIVATE_SAVE} from 'constants/contextual-help.js';
import {PUBLIC, PRIVATE, GUILD} from 'constants/save-sequence-options.js';
import '../../Modals.scss';
import ethereum from 'decentralized/ethereum.js';
import {MASTER, GROUPS} from 'constants/render-options.js';

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
class SaveModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nameValue: '',
            numTokens: 1,
            saveOption: PRIVATE,
            metamaskInstalled: true,
            showBuying: false,
            sequenceHash: undefined,
            copied: false,
            selectedGuild: undefined,
            guildOptions: [],
            renderLength: 64,
            renderOption: MASTER,
            shareWith: [],
            formingGuild: false
        };

        this.input = undefined;

        this.onClickDone = this.onClickDone.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onClickBuy = this.onClickBuy.bind(this);
        this.onClickConfirmBuy = this.onClickConfirmBuy.bind(this);
        this.onClickExport = this.onClickExport.bind(this);

        ethereum.tokenizedSequences.callback = () => this.onBalanceUpdated();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.show && nextProps.show !== this.props.show) {
            ethereum.tokenizedSequences.watchBalance();
            this.getBalance();
            this.getPrice();
            this.getGuilds();
        }
        if (!nextProps.show && nextProps.show !== this.props.show) {
            this.state.sequenceHash = undefined;
            this.state.copied = false;
        }
        return true;
    }

    async getGuilds() {
        let guilds = await ethereum.guilds.getGuildsForUser();
        if (this.props.selectedGuild !== undefined) {
            this.setState({
                saveOption: GUILD,
            });
        }
        this.setState({
            selectedGuild: this.props.selectedGuild || guilds[0],
            guildOptions: guilds.filter(x => x.name.split(",").length < 2)
        });
    }

    async getPrice() {
        let price = await ethereum.tokenizedSequences.getPrice();
        price = price * Math.pow(10, 3) / Math.pow(10, 18);
        this.setState({
            price: price,
       });
        axios.get('https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=ethereum')
            .then(res => {
                res = res.data;
                let ethPrice = parseFloat(res[0]['current_price'])
                this.setState({
                    ethPrice: ethPrice,
                });
            })
            .catch(err => {
                console.log('error getting price = ');
                console.log(err);
            });

    }

    onClickConfirmBuy() {
        this.onClickDone();
    }

    onClickBuy() {
        this.setState({
            showBuying: true,
        });
    }

    onBalanceUpdated() {
        this.setState({
            onPurchased: false,
        });

        this.getBalance();
    }

    async getBalance() {
        let balance = await ethereum.tokenizedSequences.getBalance();
        this.state.balance = balance|| 0;
        this.state.showBuying = balance === 0;
        this.setState({
            balance: balance || 0,
            showBuying: balance === 0,
        });
    }

    componentDidUpdate(newProps) {
        if (this.props.show != newProps.show) {
            if (this.input) {
                this.input.focus();
            }
            let id = this.props.sequencerEngine.sequenceId;
            if (id !== 0 || id !== -1 || id !== undefined) {
                ethereum.guildSequences.getGuildSequence(
                    id).then(
                        sequence => {
                            if (sequence) {
                                console.log("GUILD SEQUENCE =", sequence);
                                this.setState({sequenceGuildId: sequence.guildId});
                            } else {
                                this.setState({sequenceGuildId: undefined});
                            }
                        });
            }
        }

        return true;
    }

    async onClickDone() {
        this.setState({
            showExportMode: false
        });

        if (this.state.showBuying) {
            // buy the tokens
            ethereum.tokenizedSequences.buyTokens(parseInt(this.state.numTokens));
            this.setState({
                onPurchased: true,
                showBuying: false,
            });
        } else {
            let sharedWith = this.state.shareWith;
            let guildId = undefined;
            if (this.state.saveOption === PRIVATE && sharedWith.length > 0) {
                this.setState({formingGuild: true});
                guildId = await getOrMakeGuildWith(sharedWith);
                this.setState({formingGuild: false});
                this.props.onSave(this.state.nameValue, GUILD, {guildId});
            } else {
                this.props.onSave(this.state.nameValue, this.state.saveOption, this.state.selectedGuild);
            }
        }
    }

    onClickCancel() {
        if (this.state.showBuying) {
            this.setState({
                showBuying: false
            });
            return;
        }
        this.setState({
            showExportMode: false
        });
        this.props.onHide();

        let offlineEngine = this.props.sequencerEngine.state.freeze.offlineEngine;
        console.log("OFFLINE ENGINE =", offlineEngine);
        if (offlineEngine) {
            console.log("SUSPENDING");
            offlineEngine.stop();
            offlineEngine.context._context.suspend(offlineEngine.context._context.currentTime + 0.5)
                .then(() => {
                    console.log("DISPOSING");
                    offlineEngine.dispose();
                });
        }
    }

    onInputType(v) {
        this.setState({nameValue: v});
    }

    handleCheckboxChange(x) {
        this.setState({saveOption: x.target.name});
    }

    onTokenType(v) {
        if (v === '') {
            this.setState({numTokens: 0});
        }
        if (!isNumber(v)) {
            return;
        }
        this.setState({numTokens: v});
    }

    onSelectGuild(guild) {
        this.setState({
            selectedGuild: guild
        });
    }

    showExportMode(flag=true) {
        this.setState({
            showExportMode: flag
        });
    }

    onClickExport() {
        this.setState({bouncing: true});
        setTimeout(async () => {
            await bounce(this.props.sequencerEngine, this.state.renderLength, this.state.renderOption);
            this.setState({bouncing: false});
            this.onClickCancel();
            this.onClickCancel();
        }, 80);
    }

    onChangeRenderLength(length) {
        try {
            let x = parseInt(length);
            this.setState({renderLength: x});
        } catch(e) {
        }
    }

    login() {
        // this.onClickCancel();
        this.props.setShowLogin(true);
    }

    render() {
        if (this.state.showExportMode) {
            return (
            <Modal dialogClassName="preset-modal render-modal" show={this.props.show} onHide={this.onClickCancel}>
              <Modal.Header closeButton>
                <Modal.Title>Export Project</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="render-options">
                  <div className="render-label">
                    Rendered Track
                  </div>
                  <div
                    onClick={() => this.setState({renderOption: MASTER})}
                    className={
                      this.state.renderOption === MASTER ?
                          "selected render-option" : "render-option"}>
                    Master
                  </div>
                  <div
                    onClick={() => this.setState({renderOption: GROUPS})}
                    className={
                      this.state.renderOption === GROUPS ?
                          "selected render-option" : "render-option"}>
                    Groups
                  </div>
                </div>
                <div className="render-length">
                  <div className="render-label">Render Length</div>
                  <input
                    onChange={(e) => this.onChangeRenderLength(e.target.value)}
                    className="render-length-input"
                    value={this.state.renderLength} />
                </div>
                {this.state.bouncing ? <ExportProgressBar renderLength={this.state.renderLength}/> : ''}
              </Modal.Body>
              <Modal.Footer>
                {!this.state.bouncing ? 
                <Button variant="secondary" onClick={this.onClickExport}>
                  Export
                </Button> : ''}
                {!this.state.bouncing ? 
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button> : ''}
              </Modal.Footer>
            </Modal>
            );
        }

        if (!this.props.userToken) {
            return (
                <Modal dialogClassName="preset-modal save-modal" show={this.props.show} onHide={this.onClickCancel}>
                  <Modal.Header closeButton>
                    <Modal.Title>Save Sequence</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="no-metamask">
                      <span onClick={() => this.login()} className="login-btn">Login</span> to save your song to your account.
                    </div>
                    <LinkCreator onClickExport={() => this.showExportMode(true)} sequencerEngine={this.props.sequencerEngine}/>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={this.onClickCancel}>
                      Done
                    </Button>
                  </Modal.Footer>
                </Modal>
            );
        }

        if (this.state.showBuying) {
            // need to buy 
            return (
                <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.onClickCancel}>
                  <Modal.Header closeButton>
                    <Modal.Title>Buy Tokens</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="input-wrapper">
                      <input
                        value={this.state.numTokens}
                        onChange={(event) => this.onTokenType(event.target.value)}
                        ref={(input) => { this.input = input; }} 
                        placeholder="Enter how many tokens to buy"
                        className="tag-input"/>
                    </div>
                      <div className="price">
                        Price:
                        <span className="price-eth-wrapper">
                          <span className="price-eth">
                            {toFixed(this.state.numTokens * this.state.price)}
                          </span>
                           ETH 
                        </span>
                        <span className="price-dollars-wrapper">
                          <span className="price-dollars">
                            {this.state.numTokens * this.state.price * this.state.ethPrice}
                          </span>
                           USD$
                        </span>
                      </div>
                      <span onClick={this.onClickConfirmBuy} className="buy-action">Buy</span>

                      <EthereumExplanation advanced={true}/>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={this.onClickDone}>
                      Buy
                    </Button>
                    <Button variant="primary" onClick={this.onClickCancel}>
                      Cancel
                    </Button>
                  </Modal.Footer>
                </Modal>
            );
        }

        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.onClickCancel}>
              <Modal.Header closeButton>
                <Modal.Title>Save Project</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                 <input
                  value={this.state.nameValue}
                  onChange={(event) => this.onInputType(event.target.value)}
                  ref={(input) => { this.input = input; }} 
                  placeholder="Type name of project"
                  className="tag-input"/>
                   <form>
                    <input
                       name={PUBLIC}
                       type="checkbox"
                       checked={this.state.saveOption === PUBLIC}
                       onChange={(e) => this.handleCheckboxChange(e)} />
                       <label
                         onMouseOver={() => this.props.setContextualHelp(PUBLIC_SAVE)}
                         onMouseLeave={() => this.props.setContextualHelp(undefined)}

                         >Public</label>
                   <input
                       name={PRIVATE}
                       value={PRIVATE}
                       type="checkbox"
                       checked={this.state.saveOption === PRIVATE}
                       onChange={(e) => this.handleCheckboxChange(e)} />
                       <label
                         onMouseOver={() => this.props.setContextualHelp(PRIVATE_SAVE)}
                         onMouseLeave={() => this.props.setContextualHelp(undefined)}
                         >Private</label>
                   <input
                       name={GUILD}
                       value={GUILD}
                       type="checkbox"
                       checked={this.state.saveOption === GUILD}
                       onChange={(e) => this.handleCheckboxChange(e)} />
                       <label
                         onMouseOver={() => this.props.setContextualHelp(PRIVATE_SAVE)}
                         onMouseLeave={() => this.props.setContextualHelp(undefined)}
                         >Guild</label>
                   </form>
                   <ConditionedComponent condition={!this.state.metamaskInstalled}>
                     <MetamaskInstructions/>
                   </ConditionedComponent>
                   <ConditionedComponent condition={this.state.balance !== undefined && this.state.saveOption === PUBLIC}>
                     <div className="balance-info">
                       <div className="balance">
                         Balance: {this.state.balance} tokens
                         <span onClick={this.onClickBuy} className="buy-action go-to-buy">
                           Buy
                         </span>
                       </div>
                       <div>
                         Cost: 1 token
                       </div>
                       <ConditionedComponent condition={this.state.onPurchased}>
                         <span className="waiting-for-tokens">
                           Waiting for token purchase to go through...
                         </span>
                         
                         <PulseLoader
                           sizeUnit={"px"}
                           size={10}
                           color={'#62ffa1'}
                           loading={this.state.onPurchased}
                           />
                         
                       </ConditionedComponent>
                     </div>
                     <EthereumExplanation/>
                   </ConditionedComponent>
                <SaveRecordingsComponent selectedGuild={this.state.selectedGuild} sequencerEngine={this.props.sequencerEngine} />
                   <ConditionedComponent condition={this.state.saveOption === PRIVATE}>
                     <ShareWithPeople
                       guildId={this.state.sequenceGuildId}
                       onSharedWithChanged={users => this.setState({shareWith: users})}/>
                     {this.state.formingGuild ? <UnknownProgressBar text="Creating encrypted group"/> : ''}
                   </ConditionedComponent>
                   <ConditionedComponent condition={this.state.saveOption === GUILD}>
                     <GuildOptions
                       onSelectGuild={(guild) => this.onSelectGuild(guild)}
                       selectedGuild={this.state.selectedGuild}
                       guildOptions={this.state.guildOptions}/>
                   </ConditionedComponent>
                <LinkCreator
                  onClickExport={() => this.showExportMode(true)} 
                  sequencerEngine={this.props.sequencerEngine}/>
              </Modal.Body>
              
            {!this.state.formingGuild ? 
              <Modal.Footer>
                <Button variant="secondary" onClick={this.onClickDone}>
                  Save
                </Button>
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button>
              </Modal.Footer>
             : ''}
            </Modal>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setShowLogin: show=> dispatch(setShowLogin(show)),
        setContextualHelp: (help) => dispatch(setContextualHelp(help))
    };
};

const mapStateToProps = state => {
    return {
        selectedGuild: state.guilds.selectedGuild,
        userToken: state.sequencer.userToken
    }
};

function toFixed(x) {
    if (Math.abs(x) < 1.0) {
        var e = parseInt(x.toString().split('e-')[1]);
        if (e) {
            x *= Math.pow(10,e-1);
            x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
        }
    } else {
        var e = parseInt(x.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
        x /= Math.pow(10,e);
            x += (new Array(e+1)).join('0');
        }
    }
    return x;
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveModal);

